/**
 * Die Prüfbüros, die diese Anwendung benutzen.
 *
 * Die einzigen Abfragen, die über den eigenen Mandanten hinausreichen.
 * Nur für den Betreiber der Anwendung, nicht für den Kunden.
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from './klient'

export type MandantZeile = {
  id: string
  name: string
  kurzform: string
  inhaber: string | null
  ort: string | null
  aktiv: boolean
  erstellt_am: string
  anzahl_benutzer: number
  anzahl_kunden: number
  anzahl_spielplaetze: number
  anzahl_pruefungen: number
}

export function useMandanten() {
  return useQuery({
    queryKey: ['mandanten'] as const,
    queryFn: ({ signal }) => api.holen<MandantZeile[]>('/api/mandanten', signal),
  })
}

export function useMandantAnlegen() {
  const speicher = useQueryClient()
  return useMutation({
    mutationFn: (daten: {
      name: string
      kurzform: string
      ort?: string | null
      inhaber_name: string
      inhaber_email: string
    }) => api.senden<MandantZeile>('/api/mandanten', daten),
    onSuccess: () => speicher.invalidateQueries({ queryKey: ['mandanten'] }),
  })
}

export function useMandantAendern() {
  const speicher = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...daten }: { id: string } & Partial<MandantZeile>) =>
      api.aendern<MandantZeile>(`/api/mandanten/${id}`, daten),
    onSuccess: () => speicher.invalidateQueries({ queryKey: ['mandanten'] }),
  })
}
